import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AlertsService } from "src/app/core/alerts.service";
import { HelpAssistService } from "./help-assist.service";
import { HelpAssistHasScheduledTicketForRequest } from "./models/help-assist-has-schedule-ticket-for-request.model";
import { getHelpAssistTicketRouteUrl } from "./models/ticket/base-help-assist-ticket.model";

@Injectable({ providedIn: "root" })
export class HelpAssistActionsService {
  public constructor(
    private readonly alerts: AlertsService,
    private readonly helpAssist: HelpAssistService,
    private readonly router: Router,
  ) {}

  /**
   * Checks whether an open ticket already exists for the given request.
   * If one does, shows a warning and navigates to the ticket details page.
   *
   * @returns `true` if an existing ticket was found and the user was navigated away;
   * `false` if no existing ticket was found and the caller should proceed.
   */
  public async navigateToExistingTicketIfFound(
    request: HelpAssistHasScheduledTicketForRequest,
  ): Promise<boolean> {
    const existingTicket = await this.helpAssist.hasScheduledTicketFor(request);

    if (!existingTicket) {
      return false;
    }

    this.alerts.warn({
      title: "An open ticket already exists",
      message: "Cannot create a new ticket while an open ticket exists.",
    });

    await this.router.navigateByUrl(
      getHelpAssistTicketRouteUrl(existingTicket),
    );

    return true;
  }
}
